import { createContext, useContext } from "react";
const RichTextRenderMetadataContext = createContext({
  formatVersion: 0,
  referencesField: void 0,
  referenceDiscriminationField: void 0,
  referenceRenderers: {},
  references: void 0
});
RichTextRenderMetadataContext.displayName = "RichTextRenderMetadataContext";
const useRichTextRenderMetadata = () => useContext(RichTextRenderMetadataContext);
export { RichTextRenderMetadataContext, useRichTextRenderMetadata };
//# sourceMappingURL=RichTextRenderMetadataContext.js.map
